import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardContent } from '../ui/card'
import { BarChart3, FileText, ArrowRight } from 'lucide-react'
import { REPORT_CATEGORIES, reports, useReportGates } from './reportRegistry'

export const ReportHub: React.FC = () => {
  const gates = useReportGates()
  const visible = reports.filter((r) => gates[r.gate])

  return (
    <div className="container mx-auto px-4 py-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
          <BarChart3 className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Reports</h1>
          <p className="text-sm text-muted-foreground">Generate and export reports</p>
        </div>
      </div>

      {visible.length === 0 && (
        <Card>
          <CardContent className="py-12 text-center">
            <FileText className="mx-auto h-10 w-10 text-muted-foreground mb-3" />
            <p className="text-sm font-medium">No reports available</p>
            <p className="mt-1 text-sm text-muted-foreground">
              Your access level doesn&apos;t grant you any reports. Contact an administrator if you need access.
            </p>
          </CardContent>
        </Card>
      )}

      {REPORT_CATEGORIES.map((category) => {
        const categoryReports = visible.filter((r) => r.category === category)
        if (categoryReports.length === 0) return null
        return (
          <div key={category}>
            <h2 className="text-lg font-semibold mb-4">{category}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {categoryReports.map((report) => {
                const Icon = report.icon
                return (
                  <Link key={report.slug} to={`/report/${report.slug}`} className="group">
                    <Card className="h-full transition-all hover:shadow-md hover:border-primary/20">
                      <CardContent className="p-6">
                        <div className="flex items-start gap-4">
                          <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${report.iconColor}`}>
                            <Icon className="h-6 w-6" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center justify-between">
                              <h3 className="font-semibold text-lg">{report.title}</h3>
                              <ArrowRight className="h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                            </div>
                            <p className="text-sm text-muted-foreground mt-1">{report.description}</p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Link>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
